import React from 'react';

class GoogleTranslate extends React.Component {
    constructor(props) {
        super(props);
    } 

    render() {
        return (
            <div id="google_translate_element"></div>
        );
    }
}

export default GoogleTranslate;
